import ParametricsWrapper from "@televet/televet-api-middleware/src/wrappers/parametrics.wrapper";
import PatientWrapper from "@televet/televet-api-middleware/src/wrappers/patient.wrapper";
import axios from "axios";
const baseUrl = process.env.REACT_APP_GATEWAY_URL;

const ptntw = new PatientWrapper();
const prmw = new ParametricsWrapper();
export const PatientProfile = async (params, userToken, displayError = null) =>
  ptntw.patientProfile(userToken, params, displayError);

export const PatientSearch = async (userToken, params, displayError = null) =>
  ptntw.patientSearch(userToken, params, displayError);

export const PatientGet = async (id, userToken, displayError = null) =>
  ptntw.getPatientClinicHistory(userToken, id, displayError);

export const ChangeMedilinePlan = async (userToken, patient) =>
  ptntw.changePlan(userToken, patient);

export const GetPatientProfile = async (userToken, login) =>
  ptntw.getPatientProfile(userToken, login);

export const SearchPreexistingDiseases = async (userToken, diseases) =>
  prmw.searchPreexistingDiseases(userToken, diseases);

export const EnrollPlanEmail = async (email, userToken) => {
  return await axios.post(
    `${baseUrl}/services/userprofile/api/request-add-plan?userLogin=${email}`,
    null,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};

export const ChangePlanEmail = async (email, userToken) => {
  return await axios.post(
    `${baseUrl}/services/userprofile/api/change-plan?userLogin=${email}`,
    null,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};

export const CancelPlanEmail = async (email, userToken) => {
  return await axios.post(
    `${baseUrl}/services/userprofile/api/request-remove-plan?userLogin=${email}`,
    null,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
